import React from 'react';
import styled from 'styled-components';
import { GlobalToken, Modal } from 'antd';
import { useTranslation } from 'react-i18next';
import { observer } from 'mobx-react';

import { EPButton } from '@/components';

const ErrorModal = observer(({ condition, resetCallback, errorText, ...rest }): JSX.Element => {
  const { t } = useTranslation();

  return (
    <StyledModal open={condition} footer={null} closable={false} centered width={320} {...rest}>
      <div className="icon">!</div>
      <h1>{t('Something went wrong')}</h1>
      <p>{errorText}</p>
      <EPButton onClick={resetCallback}>{t('Dismiss')}</EPButton>
    </StyledModal>
  );
});

interface StyledModalProps {
  children: JSX.Element[];
  theme: { token: GlobalToken };
}

const StyledModal = styled(Modal)<StyledModalProps>`
  .ant-modal-content {
    padding: 0;

    .ant-modal-body {
      padding: ${({ theme: { token } }) => token.paddingXL}px;
      text-align: center;

      .icon {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 40px;
        height: 40px;
        border-radius: 50%;
        color: ${({ theme: { token } }) => token.colorText};
        font-size: ${({ theme: { token } }) => token.fontSizeHeading3}px;
        font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
        padding-top: ${({ theme: { token } }) => token.paddingXXS}px;
        background-color: ${({ theme: { token } }) => token.colorError};
      }

      h1 {
        font-size: ${({ theme: { token } }) => token.fontSizeXL}px;
        font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
        margin-top: ${({ theme: { token } }) => token.marginXS}px;
      }

      p {
        font-size: ${({ theme: { token } }) => token.fontSize}px;
        margin-top: ${({ theme: { token } }) => token.marginXS}px;
      }

      .ant-btn {
        margin-top: ${({ theme: { token } }) => token.marginMD}px;
      }
    }
  }
`;

export default ErrorModal;
